import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MessagesService } from '../messages/messages.service';
import { CarrierState } from '../masterdata/models/carrierState';
import { SelectableLab } from '../carrier/selectable-lab';
import { ErrorHandler } from '../utils/error-handler';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { saveAs as saveByFileSaver } from "file-saver";
import { ContainerMergeService } from '../container-merge/container-merge.service';
import { ProcessState } from '../masterdata/models/processState-enum';
import { Printer } from '../masterdata/models/printer';
import { LabProcessingRequest } from '../carrier-status/processing-request';
import { EchoFileRequest } from '../container-merge/echo-file-request';

@Component({
  selector: 'app-step-plate-preparation',
  templateUrl: './step-plate-preparation.component.html',
  styleUrls: ['./step-plate-preparation.component.css']
})
export class StepPlatePreparationComponent implements OnInit {


  reactionMixForm: FormGroup;
  checked: boolean;
  selectedCities : boolean;
  reactionCreatedby: string;
  reactionContainerBarcode: string;
 // reactionMachineBarcode: string;
  //selectedStatus: CarrierState;
  selectedLab: SelectableLab;
  isReadyForSubmit: boolean;
  submitted: boolean;
  errorHandler: ErrorHandler = new ErrorHandler;
  blocked: boolean;

  echoFileRequest:EchoFileRequest;


  @Input() carrierStateDetails: CarrierState;
  @Input() printersList : Printer[];
  selectedPrinter : Printer;
  machineNotFoundError = {
    severity: 'error',
    summary: 'Invalid Machine Barcode',
    detail: "Machine does not exists in the System"
  }

  constructor(private formBuilder: FormBuilder,
    private _messagesService: MessagesService,
    private carrierStatusService: CarrierStatusService, private containerMergeService: ContainerMergeService) {
      this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    }

  ngOnInit() {

    if(this.carrierStateDetails.printer && this.carrierStateDetails.printer.active)
    {
    this.selectedPrinter = this.carrierStateDetails.printer;
    }
    this.reactionMixForm = this.formBuilder.group({
      'reactionCreatedby': new FormControl('', Validators.required),
      'reactionContainerBarcode': new FormControl('', Validators.required),
      //'reactionMachineBarcode': new FormControl('', Validators.required),
      'reactionSelectedPrinter': new FormControl('', Validators.required),
      'checked': new FormControl('')

        });

    //this.selectedStatus = { _id: 'nonMdmId', name: ProcessStep.REACTION_MIX, lab: this.selectedLab.lab, active: true, machineType:null, printer:null };
  }

  /**
   * @function
   * @description: This method is to get the focus to Carrier Barcode Field
   */
  focusReactionContainerBarcode() {
    document.getElementById('reactionContainerBarcode').focus();
  }
  /**
   * @function
   * @description: This method is to get the focus to Machine Barcode Field
   */
  //focusReactionMachineBarcode() {
   // document.getElementById('reactionMachineBarcode').focus();
  //}

  /**
   * @function
   * @description: This method is to add entry at start of the process of the Carrier State
   */
  start() {
    this.addCarrierStatus(ProcessState.STARTED)
  }
  /**
   * @function
   * @description: This method is to add entry at cancel of the process of the Carrier State
   */
  cancel() {
    this.addCarrierStatus(ProcessState.CANCELED)
  }

  /**
   * @function
   * @description: This method is to add entry at Complete of the process of the Carrier State
   */
  complete() {
    this.addCarrierStatus(ProcessState.COMPLETED)
  }

   /**
   * @function
   * @description: This method is to add Carrier status Details
   */
  addCarrierStatus(processState: ProcessState) {

    this.blocked = true
    console.log("PS -> RM : "+this.carrierStateDetails);
  
      let status = new LabProcessingRequest;
      status.checked = this.checked;// this.userForm.get('isChecked').value;
      status.createdBy = this.reactionCreatedby;
      status.containerBarcode = this.reactionContainerBarcode.trim();
      this.carrierStateDetails.printer = this.selectedPrinter;
     // status.machineBarcode = this.reactionMachineBarcode.trim();
      status.processState = processState;
      status.lab = this.selectedLab.lab;
      status.carrierState = this.carrierStateDetails;
      status.printer = this.selectedPrinter;

      this.carrierStatusService.addCarrierStatusForPreparing(status).subscribe(
        results => {
          let ContainerStatus = results.data;
          console.log("data in the result is "+ results.data);
          if (processState == ProcessState.STARTED) {
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Process Started', detail: ContainerStatus });
          }
          else if (processState == ProcessState.CANCELED) {
            this._messagesService.addSuccessMessage({ severity: 'warning', summary: 'Process Cancelled', detail: ContainerStatus });
          }
          else if (processState == ProcessState.COMPLETED) {
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Process Completed', detail: ContainerStatus});
          }
          this.blocked = false
        },
        error => {
          if (error != null && error.error != null && error.error.bbApiError != null && error.error.bbApiError.errors != null) {
            this._messagesService.addErrorMessage({ severity: 'error', summary: error.error.bbApiError.title, detail:this.getSubErrors(error.error.bbApiError.errors) });
          }else{
            this._messagesService.addErrorMessage(this.errorHandler.handleError(error));
          }
          this.blocked = false

        }
      );
      if(processState == ProcessState.CANCELED || processState == ProcessState.COMPLETED){
        this.isReadyForSubmit = true;
      }

  }

  // used to get all the sub errors in the single string
  getSubErrors(errors:any[]){
    var errorText : string =''
    for(var e = 0; e < errors.length; e++){
      errorText += errors[e].message;
      if(e != errors.length - 1){
        errorText += (",");
      }
    }
    return errorText;
  }

  /**
   * @function
   * @description: This method is to TBD
   */
  onSubmit(value: string) {
    if (this.isReadyForSubmit) {
      this.submitted = true;
      this.reactionMixForm.reset();
      document.getElementById('reactionCreatedby').focus();
      this.isReadyForSubmit = false;
    }
  }

  /**
   * @function
   * @description: Function dowloads echo file for merged plates
   */
  downloadEchoFile() {
    this.echoFileRequest = new EchoFileRequest();
    this.echoFileRequest.containerBarcode = this.reactionContainerBarcode;
    this.echoFileRequest.labId = this.selectedLab.lab._id;
    this.containerMergeService.generateEchoFile(this.echoFileRequest).subscribe(
      result => {
        if (!result) {
          return;
        }
        let controllerFileContent = result.echoControllerFileContent;
        let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
        let fileName: string = result.data.barcode + '.csv';
        saveByFileSaver(blob, fileName);
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded Echo Control file' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
      );
    }

}
